import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
    const [randomNumber, setRandomNumber] = useState(0);

    const generateRandomNumber = () => {
        const number = Math.ceil(999000 * Math.pow(Math.random(), 10));
        setRandomNumber(number);
    }

    useEffect(() => {
        document.addEventListener('contextmenu', (event) => {
            event.preventDefault();
        });
    }, []);

    return (
        <div className="App">
            <header className="App-header">
                <h1>Exo's Random Number Generator</h1>
            </header>
            <div className="window">
                <p>Random Number: {randomNumber}</p>
                <button className="pushable" onClick={generateRandomNumber}>
                    <span className="background"></span>
                    <span className="front">Generate Random Number</span>
                </button>
            </div>
        </div>
    );
}

export default App;